let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g5Dm0")).then(() => parcelRequire('gBJum'));